/* HACHOIR CUISINE · bouton « Acheter maintenant » (branding v2, 28/10/2026)
   Ajoute l'article au panier par l'API puis envoie au checkout, sans ouvrir le tiroir panier.
   Même principe que nooko.fr. Aucun texte ici : le libellé vient du réglage du bloc,
   le message d'erreur vient de la réponse de Shopify (traduite par Shopify). */
(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function onClick(e) {
    var btn = e.target.closest('[data-hc-buy-now]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var form = document.getElementById(btn.getAttribute('data-form-id'));
    if (!form) return;
    var err = btn.parentNode.querySelector('.hc-buy-now-error');
    if (err) err.textContent = '';

    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fd.delete('sections');
    fd.delete('sections_url');

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (res.ok && !res.body.status) {
          window.location.href = root() + 'checkout';
          return;
        }
        if (err) err.textContent = (res.body && (res.body.description || res.body.message)) || '';
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      });
  }
  document.addEventListener('click', onClick, true);
})();
